import {Component, Inject, OnInit} from '@angular/core';
import {ASK_MODAL_DATA, ModalRef, ToastService} from "asksuite-citrus";
import {AnswerTemplateDto} from "../../domain/dtos";
import {DeleteAnswerTemplateUseCase} from "../../../../domain";
import {TRANSLATOR, Translator} from "@livechat/shared";
import {LoggerService} from "../../../../../../core/services/logger.service";
import {LogEvent} from "../../../../../../core/enums/log-event";
import {
  livechatTemplatesCancelDeleteAdapter,
  livechatTemplatesConfirmDeleteAdapter
} from "../../../../../../modules/live-chat/services/logger-adapters";

export type AnswerTemplateDeleteModalParams = {
  attendanceId: string;
  template: AnswerTemplateDto;
}

export type AnswerTemplateDeleteModalCloseData = {
  shouldRefresh?: boolean;
}

@Component({
  selector: 'app-answer-template-delete-modal',
  templateUrl: './answer-template-delete-modal.component.html',
  styleUrls: ['./answer-template-delete-modal.component.scss']
})
export class AnswerTemplateDeleteModalComponent implements OnInit {

  template!: AnswerTemplateDto;
  loading = false;

  constructor(
    @Inject(DeleteAnswerTemplateUseCase) private deleteAnswerTemplate: DeleteAnswerTemplateUseCase,
    @Inject(ASK_MODAL_DATA) private data: AnswerTemplateDeleteModalParams,
    @Inject(TRANSLATOR) private translate: Translator,
    private modalRef: ModalRef,
    private toast: ToastService,
    private logger: LoggerService,
  ) { }

  ngOnInit() {
    this.template = this.data.template;
  }

  protected close(data?: AnswerTemplateDeleteModalCloseData) {
    this.modalRef.close(data);
  }

  protected delete() {
    this.loading = true;
    this.deleteAnswerTemplate.execute(this.template.idAnswerTemplate).subscribe({
      next: this.onDeleteSuccess.bind(this),
      error: this.onDeleteError.bind(this)
    });
  }

  private onDeleteSuccess() {
    this.loading = false;
    this.toast.success(this.translate.key('ANSWER_TEMPLATE_DELETE_SUCCESS'));
    this.close({ shouldRefresh: true });
  }

  private onDeleteError() {
    this.loading = false;
    this.toast.danger(this.translate.key('ANSWER_TEMPLATE_DELETE_ERROR'));
  }

  protected logCancelClick() {
    this.logger.log(
      LogEvent.LIVECHAT_TEMPLATES_CANCEL_DELETE,
      livechatTemplatesCancelDeleteAdapter(this.data.attendanceId, this.data.template.idAnswerTemplate)
    )
  }

  protected logDeleteClick() {
    this.logger.log(
      LogEvent.LIVECHAT_TEMPLATES_CONFIRM_DELETE,
      livechatTemplatesConfirmDeleteAdapter(this.data.attendanceId, this.data.template.idAnswerTemplate)
    )
  }

}
